import type { FormikErrors } from 'formik';
import set from 'lodash/set';

import { getFieldError } from '@utils/forms';

import type { OrderingEligibilityRawFormValues } from '../OrderCheckEligibility/OrderCheckEligibility.validation';

/** Formik field path → API / snake_case path from eligibility validation */
type FormFieldMap = Record<string, string>;

interface CollectEligibilityFieldErrorsOptions {
  isMinorSubject?: boolean;
}

function getApiFieldToFormik(isMinorSubject: boolean): FormFieldMap {
  return {
    promoCode: 'promo_code',
    firstName: 'subject.first_name',
    lastName: 'subject.last_name',
    dob: 'subject.dob',
    sexAtBirth: 'subject.sex',
    email: 'subject.email',
    phone: 'subject.phone',
    ...(isMinorSubject
      ? {
          'guardian.firstName': 'guardian.first_name',
          'guardian.lastName': 'guardian.last_name',
          'guardian.dob': 'guardian.dob',
          'guardian.email': 'guardian.email',
          'guardian.phone': 'guardian.phone',
          'guardian.relationship': 'guardian.relationship',
        }
      : {}),
  };
}

export function collectEligibilityFieldErrors(
  errors: unknown,
  { isMinorSubject = false }: CollectEligibilityFieldErrorsOptions = {},
): FormikErrors<OrderingEligibilityRawFormValues> {
  const fieldErrors: FormikErrors<OrderingEligibilityRawFormValues> = {};

  Object.entries(getApiFieldToFormik(isMinorSubject)).forEach(([formikFieldPath, apiFieldPath]) => {
    const error = getFieldError(errors, apiFieldPath);

    if (error) {
      set(fieldErrors, formikFieldPath, error);
    }
  });

  return fieldErrors;
}
